// extracted by mini-css-extract-plugin
module.exports = {"footer":"RmFooter_footer__3tvd8"};